import {
  AccountCircle,
  CheckBoxRounded,
  Group,
  ImportContactsRounded,
  Inventory,
  Sailing,
  SwapVert,
} from "@mui/icons-material";

const admin = [
  // {
  //   href: "/",
  //   icon: <Dashboard fontSize="small" />,
  //   title: "Dashboard",
  // },
  {
    href: "/applications",
    icon: <Inventory fontSize="small" />,
    title: "Applications",
  },
  {
    href: "/agreements",
    icon: <CheckBoxRounded fontSize="small" />,
    title: "Agreements",
  },
  {
    href: "/sailors",
    icon: <Group fontSize="small" />,
    title: "Sailors",
  },
  {
    href: "/boats",
    icon: <Sailing fontSize="small" />,
    title: "Boats",
  },
  {
    href: "/dealers",
    icon: <ImportContactsRounded fontSize="small" />,
    title: "Dealers",
  },
  // {
  //   href: "/loan-calculator",
  //   icon: <Calculate fontSize="small" />,
  //   title: "Loan Calculator",
  // },
  {
    href: "/interest-rates",
    icon: <SwapVert fontSize="small" />,
    title: "Interest Rates",
  },
  {
    href: "/profile",
    icon: <AccountCircle fontSize="small" />,
    title: "Account",
  },
];

const dealer = [
  // {
  //   href: "/",
  //   icon: <Dashboard fontSize="small" />,
  //   title: "Home",
  // },
  {
    href: "/applications",
    icon: <Inventory fontSize="small" />,
    title: "Applications",
  },
  {
    href: "/profile",
    icon: <AccountCircle fontSize="small" />,
    title: "Account",
  },
];

const navigationConfig = {
  adminNavigation: admin,
  dealerNavigation: dealer,
};

export default navigationConfig;
